<template>
  <div class="modal code-task-log-modal" v-click-outside="onClose">
    <div class="pull-right">
      <div class="btn-close" @click="onClose"></div>
    </div>
    <div class="content fancy-scroll" @scroll.passive="showScrollbar">
      <div v-if="isLoading" class="content-loading">
        <LoadingSpinner :loadingCaption="'Updates werden geladen...'" />
      </div>
      <div v-else>
        <h2 class="log-modal-title">Änderungen</h2>
        <div v-for="(log, index) in logData" :key="index" class="update-block">
          <div class="user-info">
            <div class="user-details"></div>
            <div class="log-date">
              {{ getFrontDateTimeFormat(log['created']) }}
            </div>
          </div>

          <div class="log-value">
            {{ log['error-object']?.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCodeTaskLogs } from '../../services/axios/data.api';
import { debouncer } from '../../utils/helpers';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
export default {
  name: 'CodetaskLogsModal',
  props: {
    processId: {
      type: Number | String,
      required: true,
    },
    taskId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      logData: [],
    };
  },
  methods: {
    getFrontDateTimeFormat(value) {
      return new Date(parseInt(value)).toLocaleTimeString('de-DE', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: 'CET',
      });
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onClose() {
      this.$emit('onClose');
    },
  },
  async created() {
    if (this.processId) {
      try {
        this.isLoading = true;
        const res = await getCodeTaskLogs(this.processId, this.taskId);
        if (res && res.status === 200 && res.data) {
          if (res?.data?.length && res?.data?.length > 0) {
            this.logData = [...res.data].reverse();
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    }
  },
  components: { LoadingSpinner },
};
</script>
<style scoped>
.modal {
  background: #ffffff;
  border-radius: 0px;
  display: block;
  width: 438px;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  position: absolute;
  left: unset;
  top: 0;
  right: 0px;
  border-left: 1px solid #dee3e9;
  min-height: fit-content;
  overflow: hidden;
}
.code-task-log-modal .content {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 7px;
  color: #22252b;
  overflow: scroll;
  transition: 0.5s;
  min-height: fit-content;
  height: 100%;
  margin-bottom: 30px;
  height: calc(100% - 50px);
}

.code-task-log-modal .pull-right {
  position: relative;
  z-index: 3;
  transition: right 0.5s;
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.code-task-log-modal .content-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.code-task-log-modal .log-modal-title {
  font-size: 15px !important;
  letter-spacing: 0.125px;
  font-weight: 500 !important;
  line-height: 40px;
  color: #37352fa6;
  margin-top: 54px;
  margin-bottom: 10px;
}

.code-task-log-modal .update-block .user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.code-task-log-modal .update-block .user-details {
  display: flex;
  align-items: center;
  gap: 15px;
}

.code-task-log-modal .update-block .icon {
  box-sizing: content-box;
  border: 1px solid currentcolor;
  border-radius: 100%;
  width: 26px;
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-align: center;
  font-size: 14px;
  background: white;
  user-select: none;
  color: rgb(55, 53, 47);
  opacity: 1;
}
.code-task-log-modal .update-block .log-value {
  margin-top: 10px;
  background: #edebeb8c;
  padding: 10px;
  border-radius: 8px;
}

.code-task-log-modal .update-block .log-date {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.code-task-log-modal .fancy-scroll {
  padding: 0 30px;
}
.code-task-log-modal .update-block {
  padding: 20px 0;
  border-bottom: 1px solid #dee0e4;
}
.code-task-log-modal .update-block:last-child {
  border: none;
}
</style>
